/** Available support locale */
export const LOCALE_CODE = {
  EN: 'en',
  ES: 'es',
  ZH: 'zh_cn',
  KO: 'ko',
};
